import { gql } from "@apollo/client";

export const OS_PLAN_STOCK_OVERVIEW = gql`
  query OS_PLAN_STOCK_OVERVIEW {
    osPlanStockOverview
  }
`;
